import React, { Component } from "react";
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Button,
  Col,
  Row
} from "reactstrap";
// core components
import SimpleHeader from "../../../../components/Headers/SimpleHeader";
import SweetAlert from "react-bootstrap-sweetalert";
import { getWords } from '../../../../actions/glossaryActions';
import connect from 'redux-connect-decorator';

@connect(
  state => ({
    word: state.word
  }),
  {
    getWords
  }
)
class GuessMeaning extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newSet: false,
      alert: null,
      show: false,
      basicAlertIndex: 0,
      basicAlertEnglish: '',
      basicAlertVietnamese: '',
      titleAndTextAlertIndex: 1,
      titleAndTextAlertEnglish: '',
      titleAndTextAlertVietnamese: '',
      successAlertIndex: 2,
      successAlertEnglish: '',
      successAlertVietnamese: '',
      htmlAlertIndex: 3,
      htmlAlertEnglish: '',
      htmlAlertVietnamese: '',
      warningWithConfirmMessageIndex: 4,
      warningWithConfirmMessageEnglish: '',
      warningWithConfirmMessageVietnamese: '',
      warningWithConfirmAndCancelMessageIndex: 5,
      warningWithConfirmAndCancelMessageEnglish: '',
      warningWithConfirmAndCancelMessageVietnamese: '',
      inputAlertIndex: 6,
      inputAlertEnglish: '',
      inputAlertVietnamese: '',
      autoCloseAlertIndex: 7,
      autoCloseAlertEnglish: '',
      autoCloseAlertVietnamese: '',
    };
    this.hideAlert = this.hideAlert.bind(this);
    this.successDelete = this.successDelete.bind(this);
    this.cancelDetele = this.cancelDetele.bind(this);
    this.inputConfirmAlert = this.inputConfirmAlert.bind(this);
    this.inputConfirmAlertNext = this.inputConfirmAlertNext.bind(this);
  }

  componentDidMount() {
    this.props.getWords();
  }

  basicAlert = () => {
    console.log('basicAlert');
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={this.state.basicAlertVietnamese}
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
        />
      )
    });
  }
  titleAndTextAlert() {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={this.state.titleAndTextAlertEnglish}
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
        >
        </SweetAlert>
      )
    });
  }
  successAlert() {
    this.setState({
      alert: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title={this.state.successAlertEnglish}
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
        >
        </SweetAlert>
      )
    });
  }
  htmlAlert() {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={this.state.htmlAlertVietnamese}
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
        >
          {/* You can use <b>bold</b> text,{" "} */}
          {/* <a href="https://www.creative-tim.com/">links</a> and other HTML tags */}
        </SweetAlert>
      )
    });
  }
  warningWithConfirmMessage() {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title={this.state.warningWithConfirmMessageVietnamese}
          onConfirm={() => this.successDelete()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Right?"
          cancelBtnText="Wrong?"
          showCancel
        >
        </SweetAlert>
      )
    });
  }
  warningWithConfirmAndCancelMessage() {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Which one is correct?"
          onConfirm={() => this.successDelete()}
          onCancel={() => this.cancelDetele()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText={this.state.warningWithConfirmAndCancelMessageEnglish}
          cancelBtnText={this.state.titleAndTextAlertEnglish}
          showCancel
        >
        </SweetAlert>
      )
    });
  }
  autoCloseAlert() {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={this.state.autoCloseAlertEnglish}
          onConfirm={() => this.hideAlert()}
          showConfirm={false}
        >
          {this.state.autoCloseAlertVietnamese}
        </SweetAlert>
      )
    });
    setTimeout(this.hideAlert, 3000);
  }
  inputAlert() {
    this.setState({
      alert: (
        <SweetAlert
          input
          showCancel
          style={{ display: "block", marginTop: "-100px" }}
          title="Input something"
          onConfirm={e => this.inputConfirmAlert(e)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
        />
      )
    });
  }
  inputConfirmAlert(e) {
    this.setState({ alert: e });
    setTimeout(this.inputConfirmAlertNext, 200);
  }
  inputConfirmAlertNext() {
    const inputValue = this.state.alert;
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          title={
            <div>
              <p>
                You entered: <b>{inputValue}</b>
              </p>
              <p>
              Correct answer: <b>{this.state.inputAlertEnglish}</b>
              </p>
            </div>
          }
        />
      )
    });
  }
  successDelete() {
    this.setState({
      alert: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-100px" }}
          title="You are right!"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
        >
        </SweetAlert>
      )
    });
  }
  cancelDetele() {
    this.setState({
      alert: (
        <SweetAlert
          danger
          style={{ display: "block", marginTop: "-100px" }}
          title="You are wrong"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
        >
          Please try again :)
        </SweetAlert>
      )
    });
  }
  hideAlert() {
    this.setState({
      alert: null
    });
  }

  render() {
    const { words, loading } = this.props.word;

    return (
      <>
        <SimpleHeader name="Guess meaning" parentName="Games" />
        <Container className="mt--6" fluid>
          {this.state.alert}
          <Card className="mb-4">
            <CardHeader>
              <Button
                  disabled={ loading }
                  onClick={() => {
                    this.setState({
                      newSet: true,
                      basicAlertIndex: Math.floor(Math.random()*words.length),
                      basicAlertEnglish: words[this.state.basicAlertIndex].english,
                      basicAlertVietnamese: words[this.state.basicAlertIndex].vietnamese,

                      titleAndTextAlertIndex: Math.floor(Math.random()*words.length),
                      titleAndTextAlertEnglish: words[this.state.titleAndTextAlertIndex].english,
                      titleAndTextAlertVietnamese: words[this.state.titleAndTextAlertIndex].vietnamese,

                      successAlertIndex: Math.floor(Math.random()*words.length),
                      successAlertEnglish: words[this.state.successAlertIndex].english,
                      successAlertVietnamese: words[this.state.successAlertIndex].vietnamese,

                      htmlAlertIndex: Math.floor(Math.random()*words.length),
                      htmlAlertEnglish: words[this.state.htmlAlertIndex].english,
                      htmlAlertVietnamese: words[this.state.htmlAlertIndex].vietnamese,

                      warningWithConfirmMessageIndex: Math.floor(Math.random()*words.length),
                      warningWithConfirmMessageEnglish: words[this.state.warningWithConfirmMessageIndex].english,
                      warningWithConfirmMessageVietnamese: words[this.state.warningWithConfirmMessageIndex].vietnamese,

                      warningWithConfirmAndCancelMessageIndex: Math.floor(Math.random()*words.length),
                      warningWithConfirmAndCancelMessageEnglish: words[this.state.warningWithConfirmAndCancelMessageIndex].english,
                      warningWithConfirmAndCancelMessageVietnamese: words[this.state.warningWithConfirmAndCancelMessageIndex].vietnamese,

                      inputAlertIndex: Math.floor(Math.random()*words.length),
                      inputAlertEnglish: words[this.state.inputAlertIndex].english,
                      inputAlertVietnamese: words[this.state.inputAlertIndex].vietnamese,

                      autoCloseAlertIndex: Math.floor(Math.random()*words.length),
                      autoCloseAlertEnglish: words[this.state.autoCloseAlertIndex].english,
                      autoCloseAlertVietnamese: words[this.state.autoCloseAlertIndex].vietnamese,
                    });
                  }}
                  >
                New Set
              </Button>
            </CardHeader>
            <CardBody>
              {this.state.newSet 
              ? <div className="places-sweet-alerts">
                <Row>
                  <Col md={6}>
                    <Card>
                      <CardBody>
                        <div className="text-center">
                          <h5>{this.state.basicAlertEnglish}</h5>
                          <Button className="btn btn-info" onClick={this.basicAlert}>
                            Guess me!
                          </Button>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col md={6}>
                    <Card>
                      <CardBody>
                        <div className="text-center">
                          <h5>{this.state.titleAndTextAlertVietnamese}</h5>
                          <Button className="btn btn-info" onClick={this.titleAndTextAlert.bind(this)}>
                            Guess me!
                          </Button>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  
                  <Col md={6}>
                    <Card>
                      <CardBody>
                        <div className="text-center">
                          <h5>{this.state.successAlertVietnamese}</h5>
                          <Button className="btn btn-info" onClick={this.successAlert.bind(this)}>
                            Guess me!
                          </Button>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  
                  <Col md={6}>
                    <Card>
                      <CardBody>
                        <div className="text-center">
                          <h5>{this.state.htmlAlertEnglish}</h5>
                          <Button className="btn btn-info" onClick={this.htmlAlert.bind(this)}>
                            Guess me!
                          </Button>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col md={6}>
                    <Card>
                      <CardBody>
                        <div className="text-center">
                          <h5>{this.state.warningWithConfirmMessageEnglish}</h5>
                          <Button className="btn btn-info" onClick={this.warningWithConfirmMessage.bind(this)}>
                            Guess me!
                          </Button>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col md={6}>
                    <Card>
                      <CardBody>
                        <div className="text-center">
                          <h5>{this.state.warningWithConfirmAndCancelMessageVietnamese}</h5>
                          <Button className="btn btn-info" onClick={this.warningWithConfirmAndCancelMessage.bind(this)}>
                            Guess me!
                          </Button>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col md={6}>
                    <Card>
                      <CardBody>
                        <div className="text-center">
                          <h5>Remember the word in 3 seconds</h5>
                          <Button className="btn btn-info" onClick={this.autoCloseAlert.bind(this)}>
                            Guess me!
                          </Button>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col md={6}>
                    <Card>
                      <CardBody>
                        <div className="text-center">
                          <h5>{this.state.inputAlertVietnamese}</h5>
                          <Button className="btn btn-info" onClick={this.inputAlert.bind(this)}>
                            Guess me!
                          </Button>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
                </div>
              : null }
            </CardBody>
          </Card>
        </Container>
      </>
    );
  }
}
export default GuessMeaning;
